import { render } from "./SiKaoTwoView.vue?vue&type=template&id=037d0246&scoped=true&ts=true"
import script from "./SiKaoTwoView.vue?vue&type=script&lang=ts"
export * from "./SiKaoTwoView.vue?vue&type=script&lang=ts"

import "./SiKaoTwoView.vue?vue&type=style&index=0&id=037d0246&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\fushuliang\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-037d0246"]])

export default __exports__